import cx from 'classnames';
import type { ChangeEventHandler, ComponentProps, ReactNode } from 'react';
import type { Except } from 'type-fest';
import styles from './styles.module.css';

export interface RadioBehaviourProps {
  id: string;
  children: NonNullable<ReactNode>;
  name: string;
  value?: string;
  checked?: boolean;
  className?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

type InputOtherProps = Except<
  ComponentProps<'input'>,
  'type' | 'className' | 'checked' | 'value' | 'name' | 'id' | 'onChange'
>;

export function RadioBehaviour({
  id,
  children,
  checked,
  name,
  value,
  className,
  onChange,
  ...props
}: RadioBehaviourProps & InputOtherProps): ReactNode {
  return (
    <label htmlFor={id} className={cx(styles.RadioBehaviourContainer, className)}>
      <input
        type="radio"
        className={styles.InputRadioHidden}
        checked={checked}
        value={value}
        name={name}
        id={id}
        onChange={onChange}
        {...props}
      />
      {children}
    </label>
  );
}
